<template>
  <div>
    <div class='row d-none d-md-flex'>
      <div v-if="this.$store.state.numberOfTravellers>1" class='textInstructions text-center col-12 col-sm-8 offset-sm-2'>
        <span v-if='this.$store.state.site==="cibc"||this.$store.state.wantsCancellation===true'>{{$t("text.page8_alltravellers")}}</span>
        <span v-else>{{$t("text.page8_alltravellersnm")}}</span>
      </div>
      <div class='col-12 col-md-6 col-lg-4 order-2 order-sm-1'>
        <div id='product2' class='quoteItem'>
          <div class='quoteItemRecommended'></div>
          <div class='quoteItemBox'>
            <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
            <div class='quoteItemPrice'></div>
            <div class='quoteItemDescription'>
              <p></p>
              <p></p>
              <p></p>
            </div>
            <button @click="changeStep($event,'next')" class='btn btn-select' aria-label="">{{$t('text.select')}}</button>
            <center>
              <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
            </center>
          </div>
        </div>
      </div>
      <div class='col-12 col-md-6 col-lg-4 order-1 order-sm-2'>
        <div id='product1' class='quoteItem'>
          <div class='quoteItemRecommended'></div>
          <div class='quoteItemBox quoteItemBoxHighlighted'>
            <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
            <div class='quoteItemPrice'></div>
            <div class='quoteItemDescription'>
              <p></p>
              <p></p>
              <p></p>
            </div>
            <button @click="changeStep($event,'next')" class='btn btn-select' aria-label=''>{{$t('text.select')}}</button>
            <center>
              <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
            </center>
          </div>
        </div>
      </div>
      <div class='col-12 col-md-6 col-lg-4 order-3'>
        <div id='product3' class='quoteItem'>
          <div class='quoteItemRecommended'></div>
          <div class='quoteItemBox'>
            <div class='quoteItemTitle my-auto'><h2></h2></div>
            <div class='quoteItemPrice'></div>
            <div class='quoteItemDescription'>
              <p></p>
              <p></p>
              <p></p>
            </div>
            <button @click="changeStep($event,'next')" class='btn btn-select' aria-label=''>{{$t('text.select')}}</button>
            <center>
              <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
            </center>
          </div>
        </div>
      </div>
    </div>
    <div class='d-md-none'>
      <carousel id='myCarousel' :navigationEnabled="true" :perPage="1" :minSwipeDistance=100>
        <slide>
          <div id='product1m' class='quoteItem'>
            <div class='quoteItemRecommended'></div>
            <div class='quoteItemBox'>
              <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
              <div class='quoteItemPrice'></div>
              <div class='quoteItemDescription'>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <button @click="changeStep($event,'next')" class='btn btn-select' aria-label="">{{$t('text.select')}}</button>
              <center>
                <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
              </center>
            </div>
          </div>
        </slide>
        <slide v-if="this.$store.state.productCount>=2">
          <div id='product2m' class='quoteItem'>
            <div class='quoteItemRecommended'></div>
            <div class='quoteItemBox'>
              <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
              <div class='quoteItemPrice'></div>
              <div class='quoteItemDescription'>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <button @click="changeStep($event,'next')" class='btn btn-select' aria-label="">{{$t('text.select')}}</button>
              <center>
                <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
              </center>
            </div>
          </div>
        </slide>
        <slide v-if="this.$store.state.productCount>=3">
          <div id='product3m' class='quoteItem'>
            <div class='quoteItemRecommended'></div>
            <div class='quoteItemBox'>
              <div class='quoteItemTitle my-auto'><h2></h2></div>
              <div class='quoteItemPrice'></div>
              <div class='quoteItemDescription'>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <button @click="changeStep($event,'next')" class='btn btn-select' aria-label=''>{{$t('text.select')}}</button>
              <center>
                <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
              </center>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<style>
  .quoteItem {
    min-width: 275px;
    padding: 15px;
  }
  .quoteItemRecommended {
    color: #336699;
    text-align:center;
    height:25px;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .quoteItemTitle {
    text-align:center;
    height: 75px;
  }
  .quoteItemTitle h2 {
    font-weight: bold;
    color: #333333;
    font-size: 16px;
  }
  .quoteItemPrice {
    font-size: 36px;
    font-weight:300;
  }
  .quoteItemBox{
    min-height: 425px;
    text-align:center;
    padding: 25px;
    
  }
  .quoteItemBoxHighlighted {
    background-color: #F5F5F5;
  }
  .quoteItemDescription {
    padding-top:15px;
    height:250px;
  }
  .btn-select {
    display: inline-block;
    background-color: #336699;
    border-radius: 3px;
    height: 40px;
    width: 114px;
    margin-bottom: 25px;
    font-family: Arial;
    color: white;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
  }
  a.moreDetails:visited,
  a.moreDetails:active,
  a.moreDetails:hover,
  a.moreDetails:link{
    color: #AF0B1C;
    text-decoration: underline;
    font-family:arial;
  }
  .VueCarousel-navigation-button {
    border: 1px solid #CCCCCC !important;

    width: 50px;
    height: 50px;
    border-radius:100px;
    background-color: white !important;  
    color: #FFFFFF;
  }

  .VueCarousel-navigation-next {
    right:40px !important;
    box-shadow: -5px 0px 5px #ccc;
  }
  .VueCarousel-navigation-prev {
    left:40px !important;
    box-shadow: 5px 0px 5px #ccc;
  }
  .VueCarousel-inner .quoteItemBox {
    border: 1px solid black;
  }
  .VueCarousel-inner .quoteItemDescription {
    height:200px;
  }
  .VueCarousel-navigation--disabled {
    opacity: 1 !important;
    color: #CCCCCC !important;
  }
</style>

<script>
import bus from "../utils/bus.js";
import { constructProducts, buildDisplayProducts } from "../utils/constructProducts.js";
import setActiveProduct from "../utils/setActiveProduct.js";
import { Carousel, Slide } from 'vue3-carousel';

export default {
  methods: {
    changeStep(event, targetStep) {
      let doValidation;
      if (targetStep === "next") {
        targetStep = this.$route.meta.nextStep;
        doValidation=true;
      } else {
        targetStep = this.$route.meta.previousStep;
        doValidation=false;
      }
      setActiveProduct(this, event.target.getAttribute("data-product"));

      bus.$emit("changeStep", this.$route.path, targetStep, doValidation);
    },
    openCoverageDetails(event) {
      for(const category in this.$store.state.products){
        for(const product of this.$store.state.products[category].Products){
          if(event.target.getAttribute("data-product")===product.Product.ProductCode){
            bus.$emit("openCoverageDetails", product);
          }
        }
      }  
    }
  },
  created() {
    buildDisplayProducts(this);
  },
  mounted() {   
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      if(window.innerWidth<400){
        document.getElementById("myCarousel").focus();
      }
      else {
        document.getElementById("stepTitle").focus();
      }
    });
    
    // Format Step Header
    document.getElementById("stepHeader").classList.add("text-center");
    let text=this.$store.state.numberOfTravellers+" ";
    if(this.$store.state.numberOfTravellers>1){
      text = text+this.$t("text.travellersmplural");
    } else {
      text = text+this.$t("text.travellersm");
    }
    this.$nextTick(()=>{
      document.getElementById("stepTitleAppend").innerHTML=text;
    });
  
    constructProducts(this);
  }
};
</script>
